import { gql } from 'urql'

export const queryAllFeatureGroupConfigs = gql`
  query {
    feature_group_config {
      id
      names
      feature_type_id
      active
    }
  }
`

export const queryFeatureGroupConfigs = gql`
  query ($featureGroupsCondition: feature_group_config_bool_exp, $offset: Int!, $limit: Int!) {
    feature_group_config(
      where: $featureGroupsCondition
      offset: $offset
      limit: $limit
      order_by: [{ feature_group_name_locale: asc }, { id: asc }]
    ) {
      id
      feature_group_name_locale
      active
      feature_type_config {
        names
      }
      feature_group_deletability {
        is_deletable
      }
    }
    feature_group_config_aggregate(where: $featureGroupsCondition) {
      aggregate {
        count
      }
    }
  }
`

export const queryFeatureGroupConfigById = gql`
  query ($featureGroupId: Int!) {
    feature_group_config(where: { id: { _eq: $featureGroupId } }) {
      id
      names
      active
      feature_type_id
    }
  }
`

export const insertFeatureGroupConfig = gql`
  mutation ($featureGroupInsertInput: [feature_group_config_insert_input!]!) {
    insert_feature_group_config(objects: $featureGroupInsertInput) {
      affected_rows
    }
  }
`

export const updateFeatureGroupConfigById = gql`
  mutation ($featureGroupId: Int!, $featureGroupConfigSetInput: feature_group_config_set_input!) {
    update_feature_group_config(where: { id: { _eq: $featureGroupId } }, _set: $featureGroupConfigSetInput) {
      affected_rows
    }
  }
`

export const updateFeatureGroupConfigAndRelatedFeaturesByGroupId = gql`
  mutation (
    $featureGroupId: Int!
    $featureGroupConfigSetInput: feature_group_config_set_input!
    $featureConfigSetInput: feature_config_set_input!
  ) {
    update_feature_group_config(where: { id: { _eq: $featureGroupId } }, _set: $featureGroupConfigSetInput) {
      affected_rows
    }
    update_feature_config(where: { feature_group_id: { _eq: $featureGroupId } }, _set: $featureConfigSetInput) {
      affected_rows
    }
  }
`

export const deleteFeatureGroupConfigById = gql`
  mutation ($featureGroupId: Int!) {
    delete_feature_group_config(where: { id: { _eq: $featureGroupId } }) {
      affected_rows
    }
  }
`
